/**
 * Toggle a class on a specified DOM node.
 *
 * Props:
 * className(string, required): The toggled class.
 */
export default {
  name: 'toggle-class',

  ui: {
    toggler: '[js-toggle-class-toggler]',
    target: '[js-toggle-class-target]',
  },

  events: [
    {
      on: 'click',
      target: 'toggler',
      handle () {
        if (this.props.connected && !this.ui.target.classList.contains('is-open')) {
          this.el.parentNode.querySelectorAll('.is-open').forEach(openEl => {
            openEl.classList.remove('is-open')
          })
        }

        this.ui.target.classList.toggle(this.props.className)

        if (this.props.togglerClass) {
          this.ui.toggler.classList.toggle(this.props.togglerClass)
        }
      },
    },
  ],

  componentDidMount () {
    if (this.props.closeClickOutside) {
      document.body.addEventListener('click', (e) => {
        if (!e.target.closest('[js-toggle-class]') && e.target !== this.el) {
          this.ui.target.classList.remove(this.props.className)
          this.ui.toggler.classList.remove(this.props.togglerClass)
        }
      })
    }
  },
}
